module.exports = __webpack_public_path__ + "static/media/Vanilla Slice.e7348939.jpg";